import {
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory';

import type {
  ExternalCourseEnrollmentResponse,
  externalCourseTargetOrganization,
} from '@/helpers/interfaces/external-course.interface';
import type { Paginated } from '@/helpers/interfaces/paginated.interface';
import { axiosI } from '@/plugins';
import { lMSApiHandler } from '@/submodules/postman-to-ts/apiHandler/lMS';

const externalCourses = createQueryKeys('externalCourses', {
  getExternalSingleCourses: (externalCourseId: number) => ({
    queryKey: ['SingleExternalCourse', externalCourseId],
    keepPreviousData: true,
    queryFn: async () => {
      const { path, method } =
        lMSApiHandler.externalCourses.student.getSingleCourseForStudent;

      const { data: studentData } =
        await axiosI<externalCourseTargetOrganization>(
          path({ externalCourseId }),
          {
            method,
          }
        );
      let dataProgress = null;
      if (studentData.enrolledObject?.id) {
        const { path: pathProgress, method: methodProgress } =
          lMSApiHandler.externalCourses.controlBase.learnerProgress
            .learnerProgressForCourse;
        const { data } = await axiosI(
          pathProgress({
            externalCourseEnrollmentId: +studentData.enrolledObject?.id,
          }),
          {
            method: methodProgress,
          }
        );
        dataProgress = data;
      }
      return {
        studentData,
        dataProgress,
      };
    },
  }),

  getUserExternalCourses: () => ({
    queryKey: ['GetUserExternalCourses'],
    keepPreviousData: true,
    queryFn: async () => {
      const { path, method } =
        lMSApiHandler.externalCourses.student.enrolledCourses;
      return (
        await axiosI.get<Paginated<ExternalCourseEnrollmentResponse>>(path(), {
          method,
        })
      ).data;
    },
  }),

  getCornellLunchCourse: (externalCourseId: number, isCornell: boolean) => ({
    queryKey: ['GetCornellLunchCourse', externalCourseId],
    keepPreviousData: true,
    queryFn: async () => {
      const { path, method } =
        lMSApiHandler.externalCourses.student.launchCornellCourse;
      if (isCornell) {
        return (
          await axiosI.get(path({ externalCourseId }), {
            method,
          })
        ).data;
      } else {
        return [];
      }
    },
  }),
});

export const externalCoursesQueryKeys = mergeQueryKeys(externalCourses);
